import { ShoppingBag } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { useCart } from '../hooks/use-cart';
import { useCartPanel } from '../state/cart-panel-store';

/**
 * Abre a SACOLA, com a contagem de peças que de fato entram.
 *
 * Abre o painel em vez de navegar para `/carrinho`: conferir o que
 * já foi escolhido não deveria custar a página em que se estava. A rota
 * continua existindo para link direto e para quem chega de fora.
 *
 * `total_items` e não a soma de `quantity`: o backend conta o
 * `available_quantity` das linhas aceitas, que é o número que decide o
 * checkout. Mostrar o pedido faria o distintivo prometer um pedido que o
 * fechamento recusaria.
 */
export function CartButton() {
  const { data } = useCart();
  const abrir = useCartPanel((s) => s.abrir);
  const count = data?.total_items ?? 0;

  return (
    <Button
      type="button"
      onClick={() => abrir('cabecalho')}
      variant="ghost"
      size="icon-sm"
      className="relative"
      aria-label={
        count === 0
          ? 'Abrir a sacola, vazia'
          : `Abrir a sacola, com ${count} ${count === 1 ? 'peça' : 'peças'}`
      }
    >
      <ShoppingBag size={18} aria-hidden />
      {count > 0 && (
        <span
          aria-hidden
          className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[11px] font-semibold leading-none tabular-nums text-primary-foreground"
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Button>
  );
}
